import { ExtAdapter, ExtError, ExtInternalError, ExtNotSupportError, ExtParamInvalidError, ExtRejectAuthError, getExtVersionTag, trimHttp, unescapeHTML, wasmGenUnionId } from '@hyext-inner/ext-web-comp'
import { InnerExtEndpointModule } from '@hyext-inner/inner-ext-web-comp'
import md5 from 'md5'
import { BusType, EventName, HyTafFuncName, HyTafUI, HyVideoState } from '../../util/hy'
import { HyPostMessageTopic, TTPEventName } from '../../util/hy'
import { showLeadBarrageModal, showLeadGiftModal, showLeadSubscribeModal, showSendGiftModal } from '../../views/HyExtModal'
import HyExtAdapter from '../adapters/HyExtAdapter'
import HyExtAdapterInLiveRoom from '../adapters/HyExtAdapterInLiveRoom'

let isSendingGift = false

export default abstract class HyExtEndpointModule extends InnerExtEndpointModule {
  // 重载initBusiFrame，添加性能数据
  initBusiFrame(adapter: ExtAdapter, query?: string): Promise<void> {
    // 获取性能数据
    let benchmarkFps = 0
    let benchmarkCpuScore = 0
    try {
      benchmarkFps = Number(localStorage.getItem('benchmark-fps')) || 0
      benchmarkCpuScore = Number(localStorage.getItem('benchmark-cpuScore')) || 0
    } catch (err) { }

    return super.initBusiFrame(adapter, `benchmarkFps=${benchmarkFps}&benchmarkCpuScore=${benchmarkCpuScore}${query ? '&' + query : ''}`)
  }
  postMatchStatusChange(notice: any, adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.MATCH_STATUS_CHANGE, notice, adapter)
  }
  postPerspectiveChange(notice: any, adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.PERSPECTIVE_CHANGE, notice, adapter)
  }
  postObMatchEnd(notice: any, adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.OB_MATCH_END, notice, adapter)
  }
  postObMatchBegin(notice: any, adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.OB_MATCH_BEGIN, notice, adapter)
  }
  postVideoFrameReduceEnd(notice: any, adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.VIDEO_FRAME_REDUCE_END, notice, adapter)
  }
  postVideoFrameReduceStart(notice: any, adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.VIDEO_FRAME_REDUCE_START, notice, adapter)
  }
  postViewportChange(notice: any, adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.VIEW_PORT_CHANGE, notice, adapter)
  }
  postEndLive(adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.END_LIVE, {}, adapter)
  }
  postBeginLive(adapter:ExtAdapter) {
    return this.postContextMessage(TTPEventName.BEGIN_LIVE, {}, adapter)
  }
  postSubscribeChange(state:boolean, adapter:ExtAdapter) {
    return this.postContextMessage(HyPostMessageTopic.SUBSCRIBE_SUBMIT, state, adapter)
  }
  postVideoEvent(type: string, adapter:ExtAdapter) {
    const funcName = 'hyExt.player.on'
    const apiAuth = this.extEndpoint.typeAuthority.apiAuthority.value.find(a => a.apiName === funcName)
    if (!apiAuth || apiAuth.usable === 1) {
      this.extFrame.postMessageToBusiFrame(HyPostMessageTopic.PLAYER, {
        event: type
      }, adapter)
    }
  }
  async postBarrageSubmit(barrageInfo:BarrageInfo, adapter:ExtAdapter) {
    return this.postContextMessage(HyPostMessageTopic.BARRAGE_SUBMIT, barrageInfo, adapter)
  }
  async postGiftSubmit(giftInfo:GiftInfo, adapter:ExtAdapter) {
    return this.postContextMessage(HyPostMessageTopic.GIFT_SUBMIT, giftInfo, adapter)
  }
  async postVideoStateChange(notice: { state: HyVideoState }, adapter: ExtAdapter) {
    return this.postContextMessage(HyPostMessageTopic.VIDEO_STATE_CHANGE, notice, adapter)
  }
  // 业务方法
  log(req:LogReq) {
    // @ts-ignore
    this.logger[req.level](req.msg)
    return Promise.resolve()
  }
  async hySendGift(uid: number, giftId: number, giftCount: number, adapter: ExtAdapter, isAdvance: boolean, sSrcType: string) {
    if (isSendingGift) {
      return Promise.reject(new ExtNotSupportError('需要等待上一次送礼结果'))
    }  else {
      isSendingGift = true
      const hyExtAdapter = adapter as HyExtAdapter
      const { jwt } = await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
      const props = await hyExtAdapter.getGiftData()
      const giftItem = props.find(p => String(giftId) === String(p.iPropsId))
      const { lUid } = await adapter.getUserId()
      if (!isAdvance && !giftItem) {
        isSendingGift = false
        return Promise.reject(new ExtParamInvalidError(`当前直播间没有giftId为${giftId}的礼物`))
      } else if (lUid === adapter.getStreamerUid()) {
        isSendingGift = false
        return Promise.reject(new ExtNotSupportError('主播不能给自己送礼'))
      } else {
        if (!isAdvance) {
          const { sPropsPic108, sPropsWeb } = giftItem.vPropsIdentity.value[0] || {}
          try {
            await showSendGiftModal({
              extMain: this.extMain,
              extEndpoint: this.extEndpoint,
              container: await this.getModalContainer(adapter),
              sendGiftInfo: {
                giftName: giftItem.sPropsName,
                giftCount: giftCount,
                giftLogo: (sPropsPic108 || sPropsWeb || '').replace('&', '?')
              }
            })
          } catch (err) {
            isSendingGift = false
            return Promise.reject(new ExtRejectAuthError('用户拒绝送礼'))
          }
        }
        try {
          if (uid) {
            const { res, msg } = await hyExtAdapter.sendGiftToUser(uid, giftId, giftCount, sSrcType)
            if (res !== 0) {
              isSendingGift = false
              return Promise.reject(new ExtError(res, msg))
            }
          } else {
            await hyExtAdapter.sendGift(giftId, giftCount, isAdvance ? sSrcType : `applet_${this.extMain.extUuid}`)
          }
          isSendingGift = false
          return Promise.resolve()
        } catch (err) {
          isSendingGift = false
          return Promise.reject(ExtError.fromError(err))
        }
      }
    }
  }
  // 消息相关
  async deliverMsg(req:DeliverMsgReq, adapter:ExtAdapter):Promise<void> {
    const { event, message } = req
    if (typeof event === 'undefined' || !String(event)) {
      return Promise.reject(new ExtParamInvalidError('event不能为空'))
    } else if (typeof message === 'undefined' || !String(message)) {
      return Promise.reject(new ExtParamInvalidError('message不能为空'))
    } else {
      const { lUid } = await adapter.getUserId()
      if (adapter.getStreamerUid() === lUid) {
        const hyExtAdapter = adapter as HyExtAdapterInLiveRoom
        const { jwt } = await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
        const MidExtCapability = await adapter.getJCE('MidExtCapability')
        const req:MidExtCapability.DeliverRoomMsgByUnionIdReq = new MidExtCapability.DeliverRoomMsgByUnionIdReq()
        req.appId = this.extMain.authorAppId
        req.authorization = jwt
        req.event = event
        req.extUuid = this.extMain.extUuid
        req.message = message
        req.pid = adapter.getStreamerUid()
        req.request.extVersionTag = getExtVersionTag(this.extMain, this.extEndpoint)
        req.request.jwt = jwt
        req.request.sHostId = adapter.getHostId()
        req.request.componentTag = this.extEndpoint.extType
        req.roomId = Number(adapter.getRoomId())
        req.tId = await adapter.getUserId()
        return hyExtAdapter.sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.DELIVER_ROOM_MSG_BY_UNIONID, req)
      } else {
        return Promise.reject(new ExtNotSupportError('这个接口仅支持主播调用'))
      }
    }
  }
  // 订阅相关
  async leadSubscribe(_:any, adapter:ExtAdapter):Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapterInLiveRoom
    if (hyExtAdapter.roomFollow.state) {
      return Promise.reject(new ExtParamInvalidError('当前用户已经订阅了当前直播间的主播'))
    } else {
      showLeadSubscribeModal({
        extMain: this.extMain,
        extEndpoint: this.extEndpoint,
        anchorName: hyExtAdapter.TTA.nick,
        container: await this.getModalContainer(adapter),
        onOk: () => {
          hyExtAdapter.subscribe().catch(err => this.logger.warn('订阅失败', { err: err.message }))
        },
        onCancel: () => {}
      })
      return Promise.resolve()
    }
  }
  // 礼物相关
  async leadGift(_:any, adapter:ExtAdapter):Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapterInLiveRoom
    showLeadGiftModal({
      extMain: this.extMain,
      extEndpoint: this.extEndpoint,
      container: await this.getModalContainer(adapter),
      onOk: () => {
        hyExtAdapter.leadGift().catch(err => this.logger.warn('显示礼物面板失败', { err: err.message }))
      },
      onCancel: () => {}
    })
    return Promise.resolve()
  }
  onGiftChange(req:OnGiftChangeReq, adapter:ExtAdapter) {
    const { target, options } = req
    this.bus.on(BusType.GIFT, EventName.GIFT_CHANGE, giftInfo => {
      // TODO 根据options过滤
      this.extFrame.postMessageToBusiFrame(target, giftInfo, adapter)
    }, true)
    return Promise.resolve()
  }
  offGiftChange(_:any, adapter:ExtAdapter) {
    this.bus.off(BusType.GIFT, EventName.GIFT_CHANGE)
    return Promise.resolve()
  }
  async sendGift(req:SendGiftReq, adapter:ExtAdapter):Promise<void> {
    return this.hySendGift(0, req.giftId, req.giftCount, adapter, false, '')
  }
  // 弹幕相关
  async leadBarrage(_:any, adapter:ExtAdapter):Promise<void> {
    const hyExtAdapter = adapter as HyExtAdapterInLiveRoom
    showLeadBarrageModal({
      extMain: this.extMain,
      extEndpoint: this.extEndpoint,
      container: await this.getModalContainer(adapter),
      onOk: () => {
        hyExtAdapter.leadBarrage().catch(err => this.logger.warn('显示弹幕面板失败', { err: err.message }))
      },
      onCancel: () => {}
    })
    return Promise.resolve()
  }
  onBarrageChange(req:OnBarrageChangeReq, adapter:ExtAdapter) {
    const { target, options } = req
    this.bus.on(BusType.BARRAGE, EventName.BARRAGE_CHANGE, barrageInfo => {
      // TODO 根据options过滤
      this.extFrame.postMessageToBusiFrame(target, barrageInfo, adapter)
    }, true)
    return Promise.resolve()
  }
  offBarrageChange(_:any, adapter:ExtAdapter) {
    this.bus.off(BusType.BARRAGE, EventName.BARRAGE_CHANGE)
    return Promise.resolve()
  }
  // UI相关
  // 存储相关
  // 用户相关
  async getUserInfo(req:any, adapter:ExtAdapter):Promise<GetUserInfoRsp> {
    await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
    const hyAdapter = adapter as HyExtAdapterInLiveRoom
    const userInfo = await hyAdapter.getHyUserInfo()
    const { unionId } = await wasmGenUnionId(userInfo.uid, this.extMain.authorAppId, adapter)
    const { userLevel } = await hyAdapter.getHyUserLevel()
    return {
      userNick: userInfo.userNick,
      userAvatarUrl: trimHttp(userInfo.userLogo),
      userLevel,
      userUnionId: unionId
    }
  }
  // 直播间相关
  onOpenGuardianNotice(req:OnOpenGuardianNoticeReq, adapter:ExtAdapter):Promise<void> {
    const { target } = req
    this.bus.on(BusType.GUARDIAN, EventName.OPEN_GUARDIAN_NOTICE, notice => {
      this.extFrame.postMessageToBusiFrame(target, notice, adapter)
    }, true)
    return Promise.resolve()
  }
  offOpenGuardianNotice(_:any, adapter:ExtAdapter):Promise<void> {
    this.bus.off(BusType.GUARDIAN, EventName.OPEN_GUARDIAN_NOTICE)
    return Promise.resolve()
  }
  onOpenNobleNotice(req:OnOpenNobleNoticeReq, adapter:ExtAdapter):Promise<void> {
    const { target } = req
    this.bus.on(BusType.NOBLE, EventName.OPEN_NOBLE_NOTICE, notice => {
      this.extFrame.postMessageToBusiFrame(target, notice, adapter)
    }, true)
    return Promise.resolve()
  }
  offOpenNobleNotice(_:any, adapter:ExtAdapter):Promise<void> {
    this.bus.off(BusType.NOBLE, EventName.OPEN_NOBLE_NOTICE)
    return Promise.resolve()
  }
  onVipEnterBannerNotice(req:OnVipEnterBannerNoticeReq, adapter:ExtAdapter):Promise<void> {
    const { target } = req
    this.bus.on(BusType.VIP, EventName.VIP_ENTER_BANNER_NOTICE, notice => {
      this.extFrame.postMessageToBusiFrame(target, notice, adapter)
    }, true)
    return Promise.resolve()
  }
  offVipEnterBannerNotice(_:any, adapter:ExtAdapter):Promise<void> {
    this.bus.off(BusType.VIP, EventName.VIP_ENTER_BANNER_NOTICE)
    return Promise.resolve()
  }
  // 容器相关
  // 流相关
  // 文件相关
  async uploadFile(_:any, adapter:ExtAdapter):Promise<UploadFileRsp> {
    const hyExtAdapter = adapter as HyExtAdapterInLiveRoom
    const { jwt } = await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
    const inputFile = document.createElement('input')
    inputFile.setAttribute('type', 'file')
    return new Promise((resolve, reject) => {
      const handler = () => {
        const file = inputFile.files[0]
        if (file) {
          const fileExt = '.' + file.name.split('.').pop()
          const fileReader = new window.FileReader()
          fileReader.onload = async evt => {
            // @ts-ignore
            const contentMD5 = md5(evt.target.result)
            const MidExtCapability = await adapter.getJCE('MidExtCapability')
            const req:MidExtCapability.GetCommonFileUploadPolicyReq = new MidExtCapability.GetCommonFileUploadPolicyReq()
            req.tId = await adapter.getUserId()
            req.appId = this.extMain.authorAppId
            req.extUuid = this.extMain.extUuid
            req.pid = adapter.getStreamerUid()
            req.roomId = Number(adapter.getRoomId())
            req.request.componentTag = this.extEndpoint.extType
            req.request.extVersionTag = getExtVersionTag(this.extMain, this.extEndpoint)
            req.request.jwt = jwt
            req.request.sHostId = adapter.getHostId()
            // @ts-ignore
            req.auditAhead = 1 // 秩序审核形式 目前没有实现，只是预留字段
            req.bizName = 'huya_web_hyExtUpLoadFile' // 必填，业务名称，用于区分不同业务
            req.callbackUrl = '' // 尚未接秩序，默认为空
            const tafRsp: MidExtCapability.GetCommonFileUploadPolicyResp = await hyExtAdapter.sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.GET_COMMON_FILE_UPLOAD_POLICY, req)
            const formData = new window.FormData()
            formData.append('key', tafRsp.uploadDir + contentMD5.slice(0, 16) + fileExt)
            formData.append('policy', tafRsp.policy)
            formData.append('OSSAccessKeyId', tafRsp.accessId)
            formData.append('success_action_status', '200')
            formData.append('callback', tafRsp.callback)
            formData.append('signature', tafRsp.signature)
            formData.append('file', file)
            const request = new XMLHttpRequest()
            request.open('POST', tafRsp.uploadHost)
            request.onreadystatechange = () => {
              if(request.readyState === XMLHttpRequest.DONE) {
                if (request.status === 200) {
                  const json = JSON.parse(request.responseText)
                  if (json && json.status === 0) {
                    resolve({ url: json.data.fileUrl })
                  } else {
                    reject(new ExtInternalError((json && json.msg) ? json.msg : '上传错误，请联系管理员'))
                  }
                } else {
                  reject(new ExtInternalError('上传错误，请联系管理员'))
                }
              }
            }
            request.send(formData)
          }
          fileReader.readAsArrayBuffer(file)
        }
        inputFile.remove()
      }
      inputFile.addEventListener('change', handler)
      inputFile.click()
    })
  }
  // 直播间行为相关
  async showEntrance(req:ShowEntranceReq, adapter:ExtAdapter):Promise<void> {
    const tId = await adapter.getUserId()
    const { lUid } = tId
    if (lUid === adapter.getStreamerUid()) {
      const { extTypes, countDown, cornerMarkId } = req
      const MidExtCapability = await adapter.getJCE('MidExtCapability')
      const tafReq:MidExtCapability.ShowEntranceReq = new MidExtCapability.ShowEntranceReq()
      const { jwt } = await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
      tafReq.tId = tId
      tafReq.appId = this.extMain.authorAppId
      tafReq.extUuid = this.extMain.extUuid
      tafReq.pid = adapter.getStreamerUid()
      tafReq.request.componentTag = this.extEndpoint.extType
      tafReq.request.extVersionTag = getExtVersionTag(this.extMain, this.extEndpoint)
      tafReq.request.jwt = jwt
      tafReq.request.sHostId = adapter.getHostId()
      tafReq.extComponentTypeTag.value = [...extTypes.split(',')]
      tafReq.countDown = countDown
      tafReq.cornerMarkId = cornerMarkId || ''
      return (adapter as HyExtAdapterInLiveRoom).sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.SHOW_ENTRANCE, tafReq)
    } else {
      return Promise.reject(new ExtNotSupportError('这个接口仅支持主播调用'))
    }
  }
  async hideEntrance(req:HideEntranceReq, adapter:ExtAdapter):Promise<void> {
    const tId = await adapter.getUserId()
    const { lUid } = tId
    if (lUid === adapter.getStreamerUid()) {
      const { extTypes } = req
      const MidExtCapability = await adapter.getJCE('MidExtCapability')
      const tafReq:MidExtCapability.CloseEntranceReq = new MidExtCapability.CloseEntranceReq()
      const { jwt } = await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
      tafReq.tId = tId
      tafReq.appId = this.extMain.authorAppId
      tafReq.extUuid = this.extMain.extUuid
      tafReq.pid = adapter.getStreamerUid()
      tafReq.request.componentTag = this.extEndpoint.extType
      tafReq.request.extVersionTag = getExtVersionTag(this.extMain, this.extEndpoint)
      tafReq.request.jwt = jwt
      tafReq.request.sHostId = adapter.getHostId()
      tafReq.extComponentTypeTag.value = [...extTypes.split(',')]
      return (adapter as HyExtAdapterInLiveRoom).sendWup2(HyTafUI.EXT_CAPABILITY_UI, HyTafFuncName.SHOW_ENTRANCE, tafReq)
    } else {
      return Promise.reject(new ExtNotSupportError('这个接口仅支持主播调用'))
    }
  }
  // 高级接口
  async advanceSendGift(req:AdvanceSendGiftReq, adapter:ExtAdapter):Promise<void> {
    return this.hySendGift(0, req.giftId, req.giftCount, adapter, true, req.sourceType)
  }
  async sendGiftToUser(req:SendGiftToUserReq, adapter:ExtAdapter):Promise<void> {
    return this.hySendGift(req.uid, req.giftId, req.giftCount, adapter, true, req.sourceType)
  }
  async onLinkStatusChange(req:OnLinkStatusChangeReq, adapter:ExtAdapter) {
    const { target } = req
    this.bus.on(BusType.WS, EventName.WS_STATUS_CHANGE, wsStatus => {
      this.extFrame.postMessageToBusiFrame(target, wsStatus, adapter)
    }, true)
    return Promise.resolve()
  }
  // 友商接口
  // 环境相关
  // 虎牙视频相关
  // 播放器相关
  // 面板相关
  async disposal(_:any, adapter:ExtAdapter):Promise<void> {
    this.hidePanel(adapter)
    this.extFrame.unload(adapter)
  }
  // 秩序相关
  // OB相关
  // 后台相关
  async commonOperate(req:CommonOperateReq, adapter:ExtAdapter):Promise<CommonOperateRsp> {
    const { key, param } = req
    const { jwt } = await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
    const MidExtCommonOperate = await adapter.getJCE('MidExtCommonOperate')
    const tafReq:MidExtCommonOperate.CommonOperateReq = new MidExtCommonOperate.CommonOperateReq()
    tafReq.appId = this.extMain.authorAppId
    tafReq.extUuid = this.extMain.extUuid
    tafReq.functionType = key
    tafReq.paramJson = JSON.stringify(param)
    tafReq.pid = adapter.getStreamerUid()
    tafReq.request.extVersionTag = getExtVersionTag(this.extMain, this.extEndpoint)
    tafReq.request.jwt = jwt
    tafReq.request.sHostId = adapter.getHostId()
    tafReq.request.componentTag = this.extEndpoint.extType
    tafReq.tId = await adapter.getUserId()
    const tafRsp:MidExtCommonOperate.CommonOperateResp = await (adapter as HyExtAdapterInLiveRoom).sendWup2(HyTafUI.EXT_COMMON_OPERATE_UI, HyTafFuncName.COMMON_OPERATE, tafReq)
    return Promise.resolve(JSON.parse(unescapeHTML(tafRsp.responseJson)))
  }
  // 视图相关
  // PK相关
  // 连麦相关
  // websocket相关
  async wsConnect(req:WsConnectReq, adapter:ExtAdapter):Promise<WsConnectRsp> {
    const { jwt } = await this.userAuth.getAuth(adapter, this.extEndpoint, await this.getModalContainer(adapter))
    let { url } = req
    if (typeof url !== 'string' || !req.url) {
      return Promise.reject(new ExtParamInvalidError('url参数不合法'))
    } else {
      if (req.url.indexOf('?') >= 0) {
        url += '&jwt=' + encodeURIComponent(jwt)
      } else {
        url += '?jwt=' + encodeURIComponent(jwt)
      }
      return (adapter as HyExtAdapterInLiveRoom).wsConnect(url)
    }
  }
  async wsSend(req:WsSendReq, adapter:ExtAdapter):Promise<void> {
    return (adapter as HyExtAdapterInLiveRoom).wsSend(req.wsId, req.message)
  }
  async wsClose(req:WsCloseReq, adapter:ExtAdapter):Promise<void> {
    return (adapter as HyExtAdapterInLiveRoom).wsClose(req.wsId, req.code, req.reason)
  }
  onCurrentStreamNameChange(req: OnCurrentStreamNameChangReq, adapter: ExtAdapter): Promise<void> {
    const { target } = req
    this.bus.on(BusType.CURRENT_STREAM_NAME, EventName.CURRENT_STREAM_NAME_CHANGE, notice => {
      this.extFrame.postMessageToBusiFrame(target, notice, adapter)
    }, true)
    return Promise.resolve()
  }
  offCurrentStreamNameChange(_: any, adapter: ExtAdapter): Promise<void> {
    this.bus.off(BusType.CURRENT_STREAM_NAME, EventName.CURRENT_STREAM_NAME_CHANGE)
    return Promise.resolve()
  }
}
